import { pascalCase } from "pascal-case";
import slugify from "slugify";
import mixpanel from "mixpanel-browser";
import type { ParsedUrlQuery } from "querystring";
import type { MixpanelData } from "hooks/useMixpanel";
import type { TrackEventsProps } from "./trackingUtils.d";

const TRACKINGLESS_PARAM = "trackingless";

const isPageTrackingless = (query: ParsedUrlQuery) => query && query.ver === TRACKINGLESS_PARAM;

const initDataLayer = () => {
  if (!window.dataLayer) window.dataLayer = [];
};

const trackGtm = (eventData: Array<string>) => {
  if (window.dataLayer && eventData) {
    window.dataLayer.push({
      event: eventData[1],
      section: eventData[0],
      element: eventData[2],
    });
  }
};

const trackMixpanel = (eventName: string, mixpanelOptions?: MixpanelData) => {
  if (eventName) {
    mixpanel.track(eventName, mixpanelOptions);
  }
};

const trackEvents = ({ gtmEvent, mixpanelEvent, mixpanelOptions }: TrackEventsProps) => {
  initDataLayer();
  trackGtm(gtmEvent);
  trackMixpanel(mixpanelEvent, mixpanelOptions);
};

const trackClickEvent = (section: string, element: string) => {
  if (!section || !element) return;

  const event = "clicked";
  trackEvents({ gtmEvent: [pascalCase(section), event, pascalCase(element)] });
};

const buildTrackingBasedId = (section: string, element: string, suffix?: string): string => {
  const elementSuffix = suffix ? `-${suffix}` : "";
  const trackingId = `${section}-${element}${elementSuffix}`;
  const buttonIdSlugified = slugify(trackingId, { lower: true });

  return section && element ? buttonIdSlugified : null;
};

export { initDataLayer, trackEvents, trackMixpanel, isPageTrackingless, trackClickEvent, buildTrackingBasedId };
